'use client';

/**
 * Click tracking for internal CTAs on pSEO pages (comparisons, alternatives lists).
 *
 * UTM-free on purpose, same reasoning as free-tool CTAs: internal links must not
 * carry `utm_*` or they overwrite the visitor's real acquisition source (a paid
 * `switchers-t1` click would be re-labelled as our own page). First-party events
 * carry the same information without that damage. Fire-and-forget.
 */

import { emitClientEvent } from '@/lib/analytics/emit-client-event';
import { pushToDataLayer } from '@/lib/analytics/gtm';

export type PseoCtaSurface = 'hero' | 'mid_body' | 'pre_faq' | 'final' | 'hub_card' | 'related';

export interface PseoCtaClick {
  surface: PseoCtaSurface;
  /** Content slug of the page the click happened ON, e.g. alternatives/wisprs-vs-otter-ai. */
  slug: string;
  destination: string;
  label?: string;
}

export function trackPseoCtaClick({ surface, slug, destination, label }: PseoCtaClick): void {
  emitClientEvent('/api/events/conversion', {
    name: 'pseo_cta_clicked',
    surface,
    slug,
    destination,
    label,
  });
  pushToDataLayer({
    event: 'pseo_cta_clicked',
    pseo_cta_surface: surface,
    pseo_cta_slug: slug,
    pseo_cta_destination: destination,
    pseo_cta_label: label,
  });
}
